import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import WatchlistTickerAutocomplete from 'buyside/components/presentation/WatchlistTickerAutocomplete/watchlistTickerAutocomplete';

import SearchQuery from 'buyside/graphql/queries/SecuritySearch.graphql';
import FollowEntityOnboardingMutation from 'buyside/graphql/mutations/FollowEntityOnboarding.graphql';

const WatchlistTickerAutocompleteContainer = props => (
  <Query query={SearchQuery} variables={{ skip: true }}>
    {({ refetch }) => (
      <Mutation mutation={FollowEntityOnboardingMutation}>
        {followEntity => {
          return (
            <WatchlistTickerAutocomplete refetch={refetch} followEntity={followEntity} {...props} />
          );
        }}
      </Mutation>
    )}
  </Query>
);

export default WatchlistTickerAutocompleteContainer;
